import { render } from "./BaseBadge.vue?vue&type=template&id=5de3df1c&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=5de3df1c&scoped=true&lang=css"

import exportComponent from "/Users/michaelp/Library/CloudStorage/OneDrive-個人/Visual Studio/Vue Complete/auth-09-adding-auto-login/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5de3df1c"]])

export default __exports__